const attributesEmptyJson = page => {
  let result = {
    fields: [],
    actions: [],
    tabs: [],
    steps: []
  };

  const attributesFields = [
    'fieldName',
    'styleClasses',
    'hasConditions',
    'visible',
    'readonly',
    'rules',
    'fill',
    'filledBy'
  ];

  const attributesActions = ['id', 'name', 'actionName', 'visible', 'attributes', 'attributesIcon', 'params'];

  const attributesTabsHeaders = ['id', 'tabName', 'readonly', 'show'];
  const attributesStepsHeaders = ['id', 'stepName', 'show'];

  const attributesActionsFieldsTypes = {
    id: 'string',
    name: 'string',
    fieldName: 'string',
    actionName: 'string',
    attributes: 'object',
    attributesIcon: 'object',
    params: 'object',
    styleClasses: 'string',
    hasConditions: 'boolean',
    visible: 'boolean',
    readonly: 'boolean',
    rules: 'array',
    fill: 'array',
    filledBy: 'array'
  };

  const attributesTabsStepsTypes = {
    id: 'number',
    readonly: 'boolean',
    tabName: 'string',
    stepName: 'string',
    show: 'boolean'
  };

  const toType = function (obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  };

  const validateAtribute = (obj, item, attribute, type) => {
    attribute.map(i => {
      if (!item.hasOwnProperty(i)) {
        obj.errors.push(i);
        return obj;
      }

      if (type === 'field' || type === 'action') {
        if (toType(item[i]) !== attributesActionsFieldsTypes[i]) {
          obj.errors.push(i);
          return obj;
        }
      }

      if (type === 'tab' || type === 'step') {
        if (toType(item[i]) !== attributesTabsStepsTypes[i]) {
          obj.errors.push(i);
          return obj;
        }
      }
    });
  };

  const validate = (page, modes) => {
    for (let mode of modes) {
      if (page[mode]) {
        let actions = [];
        let fields = [];

        const validationFields = params => {
          if (params && params.length > 0) {
            params.forEach(field => {
              fields.push(field);

              if (field.type === 'i4proGroupButtons') {
                validationActions(field.items);
              }
            });
          }
        };

        const validationActions = params => {
          if (params && params.length > 0) {
            params.forEach(action => {
              actions.push(action);
            });
          }
        };

        if (page[mode].fields) {
          validationFields(page[mode].fields);
        }

        if (page[mode].master && page[mode].master.fields) {
          validationFields(page[mode].master.fields);
        }

        if (page[mode].groups) {
          page[mode].groups.forEach(group => {
            validationFields(group.fields);
          });
        }

        if (page[mode].tabs && page[mode].tabs.content) {
          let tabs = Object.entries(page[mode].tabs.content);

          for (let tab of tabs) {
            validationFields(tab[1].fields);

            if (tab[1].groups) {
              tab[1].groups.forEach(group => {
                validationFields(group.fields);
              });
            }
          }
        }

        if (page[mode].steps && page[mode].steps.content) {
          let steps = Object.entries(page[mode].steps.content);

          for (let step of steps) {
            validationFields(step[1].fields);

            if (step[1].groups) {
              step[1].groups.forEach(group => {
                validationFields(group.fields);
              });
            }
          }
        }

        fields.forEach(item => {
          let field = new Object({
            label: item.model,
            mode: mode,
            errors: []
          });

          validateAtribute(field, item, attributesFields, 'field');

          Object.entries(item).map(i => {
            if (attributesFields.includes(i[0]) && i[1] === '') {
              field.errors.push(i[0]);
            }
          });

          if (field.errors.length > 0) {
            result.fields.push(field);
          }
        });

        if (page[mode].actions && page[mode].actions.items) {
          if (page[mode].actions) {
            validationActions(page[mode].actions.items);
          }
        }

        if (page[mode].master && page[mode].master.actions) {
          if (page[mode].master) {
            validationActions(page[mode].master.actions);
          }
        }

        if (page[mode].tabs && page[mode].tabs.content) {
          let tabs = Object.entries(page[mode].tabs.content);

          for (let tab of tabs) {
            if (tab[1].actions) {
              validationActions(tab[1].actions.items);
            }
          }
        }

        if (page[mode].steps && page[mode].steps.content) {
          let steps = Object.entries(page[mode].steps.content);

          for (let step of steps) {
            if (step[1].actions) {
              validationActions(step[1].actions.items);
            }
          }
        }

        actions.forEach(action => {
          let schema = new Object({
            label: action.label || action.name,
            mode: mode,
            errors: []
          });

          validateAtribute(schema, action, attributesActions, 'action');

          Object.entries(action).map(i => {
            if (i[1] === '' && i[0] !== 'hidden') {
              schema.errors.push(i[0]);
            }

            if (i[0] === 'params') {
              if (!i[1].hasOwnProperty('validate')) {
                schema.errors.push(i[0]);
              }
            }
          });

          if (schema.errors.length > 0) {
            result.actions.push(schema);
          }
        });

        if (page[mode].tabs && page[mode].tabs.headers) {
          let headers = page[mode].tabs.headers;

          headers.forEach(items => {
            let header = new Object({
              label: items.title,
              mode: mode,
              errors: []
            });

            validateAtribute(header, items, attributesTabsHeaders, 'tab');

            Object.entries(items).map(item => {
              if (attributesTabsHeaders.includes(item[0]) && item[1] === '') {
                header.errors.push(item[0]);
              }
            });

            if (header.errors.length > 0) {
              result.tabs.push(header);
            }
          });
        }

        if (page[mode].steps && page[mode].steps.headers) {
          let headers = page[mode].steps.headers;

          headers.forEach(items => {
            let header = new Object({
              label: items.title,
              mode: mode,
              errors: []
            });

            validateAtribute(header, items, attributesStepsHeaders, 'step');

            Object.entries(items).map(item => {
              if (attributesStepsHeaders.includes(item[0]) && item[1] === '') {
                header.errors.push(item[0]);
              }
            });

            if (header.errors.length > 0) {
              result.steps.push(header);
            }
          });
        }
      }
    }
  };

  validate(page, ['list', 'form', 'new', 'search', 'sidebar']);

  return result;
};

export default {
  showError500: (state, payload) => {
    state.active = true;
    state.options = payload;
  },

  closeError500: state => {
    state.active = false;
    state.options = {};
  },

  jsonErrors: (state, payload) => {
    state.jsonErrors = attributesEmptyJson(payload);
  }
};
